module.exports = __webpack_public_path__ + "media/images/icon_sort_btn_comment-0c79420f345f3a0d961420ab5b526f64.png";